import { LicenceMasterData } from "./LicenceMasterData";
export class LicenceMasterDataList {
    public licenceMasterData: LicenceMasterData[] = [];
}
